document.addEventListener('DOMContentLoaded', function() {
  // Masquer Shop The Look
  const shopTheLookSections = document.querySelectorAll('.shop-the-look, [data-section-id*="shop-the-look"], [data-section-type*="shop-the-look"]');
  shopTheLookSections.forEach(section => {
    section.style.display = 'none';
  });
});